import { initScroll } from "./utils";

export const initSlider = () => {
  const sliders: NodeListOf<HTMLDivElement> = document.querySelectorAll(".slider");

  if (!sliders) {
    return;
  }

  sliders.forEach((slider) => {
    initScroll(slider);
  });
};
